import type { AllFeatureIds } from 'generated/featureIds.generated'

import { useFeatureAvailability } from 'modules/core/hooks/useFeatureAvailability'
import hasFeature from 'modules/core/lib/hasFeature'

const featureFlagMappings: Record<string, AllFeatureIds> = {
  communities_claps: 'dev_communities_kudos',
  communities_core: 'dev_communities',
}

export const useEngagementFeatureAvailability = (featureId: string): boolean => {
  const { loading: featureLoading, featureAvailability } = useFeatureAvailability(featureId)

  if (hasFeature('dev_packaging_paywalls')) {
    return !featureLoading && featureAvailability.available
  } else {
    const mappedFeature = featureFlagMappings[featureId]
    return mappedFeature ? hasFeature(mappedFeature) : false
  }
}
